import React from 'react';

import PecMailFoldersTree from './PecMailFoldersTree';
import PecMailItemViewer from './PecMailItemViewer';
import PecMailListItems from './PecMailListItems';

import { Unsubscribe } from 'redux';
import { IMailboxInUor, IMailPecMail, IProtocol } from '../../shared/interfaces';
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import { CommandBar, DefaultButton, Dropdown, FontIcon, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IconButton, IContextualMenuItem, IContextualMenuProps, IDropdownOption, IPanelStyles, mergeStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import abilityBuild from '../../shared/CASL/appAbility';
import { reduxActions, RootState } from '../../store';
import { connect, ConnectedProps } from 'react-redux';
import { RoleContext, Visibility_Type } from '../../shared/enums';
import { checkRoles } from '../../hoc/CheckRoles';
import { subject } from '@casl/ability';
import { withRouter, RouteComponentProps, Switch, Route } from 'react-router-dom'
import RippleLoader from '../Loader/RippleLoader/RippleLoader';
import { matchPath } from 'react-router'
import MailProtocolWizard from './MailProtocolWizard/MailProtocolWizard';
import { MailProtocolWizardReduxState } from '../../store/mail-protocol-wizard/types';
import { myTheme } from '../../assets/styles/my-theme';
import { toastRef } from '../Layout/Layout';

const queryString = require('query-string');
const { palette } = myTheme;

const folderTreePathString = "/:aooId/pecmail/:mailboxAddress";
const mailListItemsPathString = "/:aooId/pecmail/:mailboxAddress/:folderId";
const mailItemViewerPathString = "/:aooId/pecmail/:mailboxAddress/:folderId/:mailId";
const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};


const mapState = (state: RootState) => ({
    lateralPanelMailProtocolWizardIsOpen: state.mailProtocolWizardReducer.lateralPanelMailProtocolWizardIsOpen,
    selectedMail: state.mailProtocolWizardReducer.selectedMail,
    selectedMailboxAddress: state.mailProtocolWizardReducer.selectedMailboxAddress,

    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {
    updateMailProtocolWizardState: (newState: Partial<MailProtocolWizardReduxState>) => (reduxActions.mailProtocolWizardActions.updateMailProtocolWizardState(newState)),

}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface PecMailLayoutProps {

}
type Props = PecMailLayoutProps & RouteComponentProps & PropsFromRedux


export interface PecMailLayoutState {
    commandBarItems: ICommandBarItemProps[]
    mailboxesOptions: IContextualMenuItem[]
    showActionsLoader: boolean
    showMessageBar: boolean
    messageBarType: MessageBarType
    messageBarText: string
    selectedForlderId: number
    forceRefresh: boolean
}

class PecMailLayout extends React.Component<Props, PecMailLayoutState> {
    unsubscribeFromAbility: Unsubscribe = () => { };

    constructor(props) {
        super(props);

        this.state = {
            commandBarItems: [],
            mailboxesOptions: [],
            showActionsLoader: false,
            showMessageBar: false,
            messageBarType: MessageBarType.info,
            messageBarText: "",
            selectedForlderId: 0,
            forceRefresh: false
        }
    }

    componentDidMount() {
        let { currentUor } = this.props
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };
            if (abilityBuild.cannot('create', subject('IProtocol', prot))) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
        });

        if (currentUor && currentUor.mailboxesIn) {
            let options = currentUor
                .mailboxesIn.map(el => (
                    {
                        key: el.mailbox.address,
                        text: el.mailbox.address,
                        data: el,
                        onClick: () => this.onSelectMailboxes(el.mailbox.address)
                    }))

            this.setState({
                mailboxesOptions: options
            });

        }
        this.getParamsValuesFromUrl();

        this.updateCommandBarItems();

    }

    componentDidUpdate(oldProps: Props, oldState: PecMailLayoutState) {
        if (oldProps.location.pathname !== this.props.location.pathname) {
            this.getParamsValuesFromUrl();
        }

        if (oldProps.currentUor !== this.props.currentUor && this.props.currentUor && this.props.currentUor.mailboxesIn) {
            let options = this.props.currentUor
                .mailboxesIn.map(el => (
                    {
                        key: el.mailbox.address,
                        text: el.mailbox.address,
                        data: el,
                        onClick: () => this.onSelectMailboxes(el.mailbox.address)
                    }))

            this.setState({
                mailboxesOptions: options
            }, () => { this.updateCommandBarItems(); });

        }

        if (oldProps.selectedMail !== this.props.selectedMail || oldProps.selectedMailboxAddress !== this.props.selectedMailboxAddress) {
            this.updateCommandBarItems();
        }


    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    getParamsValuesFromUrl() {
        const { location } = this.props;

        // Uso matchPath per prendere i parametri dai path dei component figli
        let newSelectedMailboxAddress = undefined;
        const matchFolderTreePath = matchPath(location.pathname, {
            path: folderTreePathString,
            exact: true
        })
        if (matchFolderTreePath) {
            newSelectedMailboxAddress = matchFolderTreePath.params['mailboxAddress'];
        }
        const matchMailListItemsPath = matchPath(location.pathname, {
            path: mailListItemsPathString,
            exact: true
        })
        if (matchMailListItemsPath) {
            newSelectedMailboxAddress = matchMailListItemsPath.params['mailboxAddress'];
        }
        const matchMailItemViewerPathString = matchPath(location.pathname, {
            path: mailItemViewerPathString,
            exact: true
        })
        if (matchMailItemViewerPathString) {
            newSelectedMailboxAddress = matchMailItemViewerPathString.params['mailboxAddress'];
        }
        this.props.updateMailProtocolWizardState({ selectedMailboxAddress: newSelectedMailboxAddress });
        if (!newSelectedMailboxAddress) {
            let op = this.state.mailboxesOptions && this.state.mailboxesOptions.length > 0 ? this.state.mailboxesOptions[0].key : '';
            this.onSelectMailboxes(op);
        }

    }


    updateCommandBarItems = () => {


        let newCommandBarItems: ICommandBarItemProps[] = [];

        let cassette = this.state.mailboxesOptions.filter(el => el.key != this.props.selectedMailboxAddress);
        newCommandBarItems.push(
            {
                key: 'selectMailbox',
                text: this.props.selectedMailboxAddress ? this.props.selectedMailboxAddress : 'Seleziona una cassetta',
                subMenuProps: this.state.mailboxesOptions && this.state.mailboxesOptions.length > 1 && cassette && cassette.length > 0 ? { items: cassette } : undefined,
            },
        );
        newCommandBarItems.push(
            {
                key: 'update',
                iconProps: { iconName: 'Refresh' },
                text: 'Aggiorna',
                onClick: this.updatePecListItemsHandler
            });


        let { selectedMail, currentUor } = this.props

        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: uorId } }] };

        if (selectedMail && currentUor
            && abilityBuild.can('use', subject('IFeature', { key: 'PecMail', enabled: true }))
            && abilityBuild.can('create', subject('IProtocol', prot))) {

            newCommandBarItems.push({
                key: 'createProtocol',
                iconProps: { iconName: 'Send' },
                text: 'Crea protocollo',
                onClick: this.createProtocolHandler
            });
        }

        this.setState({ commandBarItems: newCommandBarItems });

    }

    // Click sul button della commandbar
    updatePecListItemsHandler = () => {
        this.updateCommandBarItems();

        let path = `/${this.props.currentAoo!.id}/pecmail/${this.props.selectedMailboxAddress}/${this.state.selectedForlderId}`;

        this.props.history.push({ pathname: path, search: this.props.location.search });

        let { forceRefresh } = this.state
        this.setState({ forceRefresh: !forceRefresh });
    }


    // Click sul button della commandbar
    createProtocolHandler = (ev: any, item: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        let mail = this.props.selectedMail as IMailPecMail;

        // inibisco la protocollazione delle mail non ancora completate
        let isMailCompleted: boolean =
               (mail.tipologia === "RICEVUTA" && mail.statoRicevuta === "Completato") //Pec Inviata
            || (mail.tipologia === "RICEVUTA" && mail.statoRicevuta === "Completato con errori") //Pec Inviata
            || (mail.tipologia === "RICEVUTA" && mail.statoRicevuta === "Non Accettata") //Pec Inviata
            || (mail.tipologia === "Posta inviata" && !mail.statoRicevuta) //Peo Inviata
            || (mail.tipologia === "POSTA CERTIFICATA" && !mail.statoRicevuta) //Pec in entrata
            || (mail.tipologia === "ANOMALIA MESSAGGIO" && !mail.statoRicevuta) //Pec in entrata
            || (mail.tipologia === "Posta non certificata" && !mail.statoRicevuta); //Peo in entrata

        if (isMailCompleted) {
            this.props.updateMailProtocolWizardState({ lateralPanelMailProtocolWizardIsOpen: true });
        } else {
            toastRef.current?.show({
                severity: 'warn',
                summary: "Attenzione",
                detail: "Mail in attesa di ricevute, riprovare più tardi",
                life: 5000
            });
        }

    }




    onSelectMailboxes = (selectedMailbox: string) => {

        let path = `/${this.props.currentAoo!.id}/pecmail/${selectedMailbox}`;

        this.props.history.push({ pathname: path, search: this.props.location.search });

    }




    render() {
        let showLoaderClass = this.state.showActionsLoader ? "active" : '';

        return (
            <React.Fragment>
                <div className={"loader opacity " + showLoaderClass}>
                    <RippleLoader text='Creazione bozza protocollo' />
                </div>
                <div className="pecmail-layout-wrapper">
                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}

                        />
                    }

                    {
                        this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}
                        </MessageBar>
                    }

                    <div className="pecmail-layout-content">
                        <div className="pecmail-layout-folders-tree">

                            <Switch>


                                <Route path={folderTreePathString} key="foldersTree" exact={false}
                                    render={props => {
                                        return (
                                            <React.Fragment>
                                                <PecMailFoldersTree onSelectFolder={(folderId) => this.setState({ selectedForlderId: folderId })} />
                                            </React.Fragment>
                                        );
                                    }}
                                >
                                </Route>
                            </Switch>


                        </div>
                        <div className="pecmail-layout-list-items-wrapper">
                            <Switch>


                                <Route path={mailListItemsPathString} key="mailListItems" exact={false}
                                    render={props => {
                                        return (
                                            <React.Fragment>
                                                <PecMailListItems forceRefresh={this.state.forceRefresh} />
                                            </React.Fragment>
                                        );
                                    }}
                                >
                                </Route>


                            </Switch>


                        </div>
                        <div className="pecmail-layout-item-viewer">
                            <Switch>


                                <Route path={mailItemViewerPathString} key="mailItemViewer" exact={false}
                                    render={props => {
                                        return (
                                            <React.Fragment>
                                                <PecMailItemViewer selectedMail={this.props.selectedMail} />
                                            </React.Fragment>
                                        );
                                    }}
                                >
                                </Route>
                                <Route path={mailListItemsPathString} render={props => {
                                    return (
                                        <div className='no-mail' >
                                            <span>
                                                <FontIcon iconName="Mail" className={mergeStyles({
                                                    fontSize: 80,
                                                    height: 80,
                                                    width: 80,
                                                    margin: '0 25px',
                                                    color: palette.themePrimary
                                                })} /></span>
                                            <span>Seleziona un elemento da leggere</span>
                                        </div>
                                    );
                                }} />

                            </Switch>

                        </div>
                    </div >
                </div >
                {this.props.lateralPanelMailProtocolWizardIsOpen &&
                    <MailProtocolWizard />
                }

            </React.Fragment >
        );
    }
}
export default connector(withRouter(checkRoles(PecMailLayout, RoleContext.Uor)));
